import { IVector } from "../interfaces";
import { IZoomInOn, IZoomOnPosition, IZoomOnSpace, IZoomOnXY, IIgnoreZoom } from "../interfaces/IZoom";
import { IZoomLevel } from "../interfaces/IZoomLevel";
import { Point } from "../models/point";

export class ZoomUtils {
	public static isZoomOnSpace(object: IZoomInOn): object is IZoomOnSpace {
		return (object as IZoomOnSpace).space != null;
	}

	public static isZoomOnPosition(object: IZoomInOn): object is IZoomOnPosition {
		return (object as IZoomOnPosition).viewFromPosition != null;
	}

	public static isZoomOnXY(object: IZoomInOn): object is IZoomOnXY {
		return (object as IZoomOnXY).coordinatesXYPercentage != null;
	}

	public static isIgnoreZoom(object: IZoomInOn): object is IIgnoreZoom {
		return true;
	}

	public static zoomInOnSpace(zoomTo: IZoomOnSpace, viewer: Autodesk.Viewing.GuiViewer3D): void {
		if (zoomTo.space.dbId) {
			viewer.select(zoomTo.space.dbId);
			viewer.fitToView([zoomTo.space.dbId], viewer.model, true);

			setTimeout(() => {
				const camera: any = viewer.getCamera();
				camera.position.z += 25;
				viewer.navigation.setView(camera.position, camera.target);
			}, 200);
		}
	}

	public static zoomToInitial(initial: IVector, viewer: Autodesk.Viewing.GuiViewer3D): void {
		this.zoomInOnPosition({ viewAtPosition: initial as Point, viewFromPosition: initial as Point, zoomLevel: initial.z }, viewer);
	}

	public static zoomInOnPosition(zoomTo: IZoomOnPosition, viewer: Autodesk.Viewing.GuiViewer3D): void {
		if (!viewer.model) {
			return;
		}

		const camera: any = viewer.getCamera();
		camera.position.set(zoomTo.viewFromPosition.x, zoomTo.viewFromPosition.y, zoomTo.zoomLevel);
		camera.target.set(zoomTo.viewAtPosition.x, zoomTo.viewAtPosition.y, 0);

		viewer.navigation.setView(camera.position, camera.target);
	}

	public static zoomInOnXY(zoomTo: IZoomOnXY, viewer: Autodesk.Viewing.GuiViewer3D): void {
		if (!viewer.model || zoomTo.coordinatesXYPercentage.length !== 2) {
			return;
		}

		const scale = 100;
		let xPercentage = zoomTo.coordinatesXYPercentage[0];
		let yPercentage = zoomTo.coordinatesXYPercentage[1];
		xPercentage = xPercentage > scale ? scale : xPercentage;
		yPercentage = yPercentage > scale ? scale : yPercentage;

		const defaultModelBoxSize = viewer.model.getBoundingBox().getSize();
		const position = new THREE.Vector3((defaultModelBoxSize.x / scale) * xPercentage, (defaultModelBoxSize.y / scale) * yPercentage, 0);

		const camera: any = viewer.getCamera();

		ZoomUtils.zoomInOnPosition(
			{ viewFromPosition: position, zoomLevel: zoomTo.zoomLevel, viewAtPosition: Point.FromVector(camera.target) },
			viewer
		);
	}

	public static zoomInOnModel(viewer: Autodesk.Viewing.GuiViewer3D): void {
		viewer.fitToView();
	}

	public static setZoomLimit(viewer: Autodesk.Viewing.GuiViewer3D): void {
		if (!viewer.model) {
			return;
		}

		const navigation: any = viewer.navigation;
		navigation.setZoomInLimitFactor(10);
		navigation.setConstraints2D(viewer.model.getData().bbox);
	}

	public static getCurrentZoomLevel(viewer: Autodesk.Viewing.GuiViewer3D): IZoomLevel {
		const camera: any = viewer.getCamera();

		return {
			position: camera.position,
			target: camera.target,
		};
	}
}
